import { TokenWebViewRequest, TokenWebViewResponse } from '../../models/TokenDto';

const generateErrorResponse = (error?: any): TokenWebViewResponse => {
  return {
    data: {
      apiAccessToken: '',
    },
    meta: {},
    result: {
      status: error ? 500 : 200,
      message: '',
      code: '',
    },
  };
};

export default async function fetchWebviewAccessToken({
  apiAccessToken,
  deviceKey,
}: Partial<TokenWebViewRequest>): Promise<TokenWebViewResponse> {
  if (!apiAccessToken || !deviceKey) {
    return generateErrorResponse();
  }

  try {
    const apiEndpoint = `http://api-authentication.${process.env.TARGET_ENV_PREFIX}myrealtrip.net/internal/authentication/v3/token/refresh/webview`;
    const response = await fetch(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ apiAccessToken, deviceKey }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    return generateErrorResponse(error);
  }
}
